import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";

export default observer(function ChatUserActionsButton() {
	const { chatViewStore } = useRootAppStore();
	const [isHover, setIsHover] = useState(false);

	const { leaveChannelDropdownOpened, setLeaveChannelDropdownOpened } =
		chatViewStore;

	const toggleMuteDropdown = () => {
		setLeaveChannelDropdownOpened(!leaveChannelDropdownOpened);
	};

	const handleButtonClick = () => {
		toggleMuteDropdown();
		setIsHover((prevIsHover) => !prevIsHover);
	};

	const { t } = useTranslation();

	const iconClasses = classNames(
		"u-icon u-icon--sml u-color--text--primary",
		{
			"u-icon--chat-menu": !isHover,
			"u-icon--chat-menu--selected": isHover,
		}
	);

	return (
		<>
			<button
				className="btn btn--square btn--square--tny btn--icon btn--secondary--inverted"
				onClick={handleButtonClick}
			>
				<i className={iconClasses} />
			</button>
			{leaveChannelDropdownOpened && (
				<div className={"chat__options"}>
					<button
						onClick={() => {
							setLeaveChannelDropdownOpened(false);
							chatViewStore.leaveCurrentChannel();
						}}
						className="btn btn--base btn--block btn--icon btn--secondary--inverted"
					>
						<i className="u-icon u-icon--sml u-icon--chat--leave" />
						<span className="u-color--sent--danger">
							{t("CHAT.LEAVE_CHAT")}
						</span>
					</button>
				</div>
			)}
		</>
	);
});
